import React, { Component } from 'react';

import './twoColumnLayout.scss';

const TwoColumnLayoutHOC = function(WrappedComponentLeft, WrappedComponentRight) {
  return class TwoColumnLayout extends Component {
    render() {
      return (
        <div className="two-column-layout">
          <WrappedComponentLeft className="column left" />
          <WrappedComponentRight className="column right" />
        </div>
      );
    }
  };
};

export { TwoColumnLayoutHOC };



// WEBPACK FOOTER //
// ./src/containers/layouts/TwoColumnLayout/TwoColumnLayoutHOC.jsx